import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/motions';

const namespace = 'MOTIONS';

export const FETCH_MOTIONS_START = `${namespace}/FETCH_MOTIONS_START`;
export const FETCH_MOTIONS_SUCCESS = `${namespace}/FETCH_MOTIONS_SUCCESS`;
export const FETCH_MOTIONS_ERROR = `${namespace}/FETCH_MOTIONS_ERROR`;

export const fetchMotions = makeApiActionCreatorV3(
  api.fetchMotions,
  FETCH_MOTIONS_START,
  FETCH_MOTIONS_SUCCESS,
  FETCH_MOTIONS_ERROR,
);

export const FETCH_MOTION_START = `${namespace}/FETCH_MOTION_START`;
export const FETCH_MOTION_SUCCESS = `${namespace}/FETCH_MOTION_SUCCESS`;
export const FETCH_MOTION_ERROR = `${namespace}/FETCH_MOTION_ERROR`;

export const fetchMotion = makeApiActionCreatorV3(
  api.fetchMotion,
  FETCH_MOTION_START,
  FETCH_MOTION_SUCCESS,
  FETCH_MOTION_ERROR,
);

export const FETCH_MOTION_FILES_START = `${namespace}/FETCH_MOTION_FILES_START`;
export const FETCH_MOTION_FILES_SUCCESS = `${namespace}/FETCH_MOTION_FILES_SUCCESS`;
export const FETCH_MOTION_FILES_ERROR = `${namespace}/FETCH_MOTION_FILES_ERROR`;

export const fetchMotionFiles = makeApiActionCreatorV3(
  api.fetchMotionFiles,
  FETCH_MOTION_FILES_START,
  FETCH_MOTION_FILES_SUCCESS,
  FETCH_MOTION_FILES_ERROR,
);

export const FETCH_CODEFILE_MOTION_STATUS_START = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_START`;
export const FETCH_CODEFILE_MOTION_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_SUCCESS`;
export const FETCH_CODEFILE_MOTION_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_MOTION_STATUS_ERROR`;

export const fetchCodefileMotionStatus = makeApiActionCreatorV3(
  api.fetchCodefileMotionStatus,
  FETCH_CODEFILE_MOTION_STATUS_START,
  FETCH_CODEFILE_MOTION_STATUS_SUCCESS,
  FETCH_CODEFILE_MOTION_STATUS_ERROR,
);

export const FETCH_CODEFILE_FILING_PARTY_START = `${namespace}/FETCH_CODEFILE_FILING_PARTY_START`;
export const FETCH_CODEFILE_FILING_PARTY_SUCCESS = `${namespace}/FETCH_CODEFILE_FILING_PARTY_SUCCESS`;
export const FETCH_CODEFILE_FILING_PARTY_ERROR = `${namespace}/FETCH_CODEFILE_FILING_PARTY_ERROR`;

export const fetchCodefileFilingParty = makeApiActionCreatorV3(
  api.fetchCodefileFilingParty,
  FETCH_CODEFILE_FILING_PARTY_START,
  FETCH_CODEFILE_FILING_PARTY_SUCCESS,
  FETCH_CODEFILE_FILING_PARTY_ERROR,
);

export const INSERT_MOTION_START = `${namespace}/INSERT_MOTION_START`;
export const INSERT_MOTION_SUCCESS = `${namespace}/INSERT_MOTION_SUCCESS`;
export const INSERT_MOTION_ERROR = `${namespace}/INSERT_MOTION_ERROR`;

export const insertMotion = makeApiActionCreatorV3(
  api.insertMotion,
  INSERT_MOTION_START,
  INSERT_MOTION_SUCCESS,
  INSERT_MOTION_ERROR,
);

export const INSERT_MOTION_FILE_START = `${namespace}/INSERT_MOTION_FILE_START`;
export const INSERT_MOTION_FILE_SUCCESS = `${namespace}/INSERT_MOTION_FILE_SUCCESS`;
export const INSERT_MOTION_FILE_ERROR = `${namespace}/INSERT_MOTION_FILE_ERROR`;

export const insertMotionFile = makeApiActionCreatorV3(
  api.insertMotionFile,
  INSERT_MOTION_FILE_START,
  INSERT_MOTION_FILE_SUCCESS,
  INSERT_MOTION_FILE_ERROR,
);

export const UPDATE_MOTION_START = `${namespace}/UPDATE_MOTION_START`;
export const UPDATE_MOTION_SUCCESS = `${namespace}/UPDATE_MOTION_SUCCESS`;
export const UPDATE_MOTION_ERROR = `${namespace}/UPDATE_MOTION_ERROR`;

export const updateMotion = makeApiActionCreatorV3(
  api.updateMotion,
  UPDATE_MOTION_START,
  UPDATE_MOTION_SUCCESS,
  UPDATE_MOTION_ERROR,
);

export const UPDATE_MOTION_TAGS_START = `${namespace}/UPDATE_MOTION_TAGS_START`;
export const UPDATE_MOTION_TAGS_SUCCESS = `${namespace}/UPDATE_MOTION_TAGS_SUCCESS`;
export const UPDATE_MOTION_TAGS_ERROR = `${namespace}/UPDATE_MOTION_TAGS_ERROR`;

export const updateMotionTags = makeApiActionCreatorV3(
  api.updateMotionTags,
  UPDATE_MOTION_TAGS_START,
  UPDATE_MOTION_TAGS_SUCCESS,
  UPDATE_MOTION_TAGS_ERROR,
);

export const UPDATE_MOTION_FILE_START = `${namespace}/UPDATE_MOTION_FILE_START`;
export const UPDATE_MOTION_FILE_SUCCESS = `${namespace}/UPDATE_MOTION_FILE_SUCCESS`;
export const UPDATE_MOTION_FILE_ERROR = `${namespace}/UPDATE_MOTION_FILE_ERROR`;

export const updateMotionFile = makeApiActionCreatorV3(
  api.updateMotionFile,
  UPDATE_MOTION_FILE_START,
  UPDATE_MOTION_FILE_SUCCESS,
  UPDATE_MOTION_FILE_ERROR,
);

export const DELETE_MOTION_START = `${namespace}/DELETE_MOTION_START`;
export const DELETE_MOTION_SUCCESS = `${namespace}/DELETE_MOTION_SUCCESS`;
export const DELETE_MOTION_ERROR = `${namespace}/DELETE_MOTION_ERROR`;

export const deleteMotion = makeApiActionCreatorV3(
  api.deleteMotion,
  DELETE_MOTION_START,
  DELETE_MOTION_SUCCESS,
  DELETE_MOTION_ERROR,
);

export const DELETE_MOTION_FILE_START = `${namespace}/DELETE_MOTION_FILE_START`;
export const DELETE_MOTION_FILE_SUCCESS = `${namespace}/DELETE_MOTION_FILE_SUCCESS`;
export const DELETE_MOTION_FILE_ERROR = `${namespace}/DELETE_MOTION_FILE_ERROR`;

export const deleteMotionFile = makeApiActionCreatorV3(
  api.deleteMotionFile,
  DELETE_MOTION_FILE_START,
  DELETE_MOTION_FILE_SUCCESS,
  DELETE_MOTION_FILE_ERROR,
);

export const DOWNLOAD_MOTION_FILE_START = `${namespace}/DOWNLOAD_MOTION_FILE_START`;
export const DOWNLOAD_MOTION_FILE_SUCCESS = `${namespace}/DOWNLOAD_MOTION_FILE_SUCCESS`;
export const DOWNLOAD_MOTION_FILE_ERROR = `${namespace}/DOWNLOAD_MOTION_FILE_ERROR`;

export const downloadMotionFile = makeApiActionCreatorV3(
  api.downloadMotionFile,
  DOWNLOAD_MOTION_FILE_START,
  DOWNLOAD_MOTION_FILE_SUCCESS,
  DOWNLOAD_MOTION_FILE_ERROR,
);

export const FETCH_CODEFILE_MOTION_TYPE_START = `${namespace}/FETCH_CODEFILE_MOTION_TYPE_START`;
export const FETCH_CODEFILE_MOTION_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_MOTION_TYPE_SUCCESS`;
export const FETCH_CODEFILE_MOTION_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_MOTION_TYPE_ERROR`;

export const fetchCodefileMotionType = makeApiActionCreatorV3(
  api.fetchCodefileMotionType,
  FETCH_CODEFILE_MOTION_TYPE_START,
  FETCH_CODEFILE_MOTION_TYPE_SUCCESS,
  FETCH_CODEFILE_MOTION_TYPE_ERROR,
);
